import React from "react";
import { BUSINESS, DISCLAIMER } from "@/constants/landingCopy";
import { Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer style={{ backgroundColor: "#1A2B4A" }}>
      <div className="container-max py-12">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div>
            <div className="font-head font-extrabold text-2xl">
              <span style={{ color: "#F5A623" }}>StarPower</span>
              <span className="text-white">.Network</span>
            </div>
            <p className="font-body italic mt-2 text-white/70">Maui&apos;s Solar &amp; Electrical Experts</p>
          </div>

          <div className="font-body text-white/80 space-y-2">
            <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-2 hover:text-[#F5A623]">
              <Mail size={16} /> {BUSINESS.email}
            </a>
            <a href={BUSINESS.phoneHref} className="flex items-center gap-2 hover:text-[#F5A623]">
              <Phone size={16} /> {BUSINESS.phone}
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6" style={{ borderTop: "1px solid rgba(255,255,255,0.12)" }}>
          <p className="font-body text-sm text-white/55">
            &copy; 2026 Maui StarPower Network LLC. All rights reserved.
          </p>
          <p className="font-body text-xs text-white/45 mt-2 max-w-4xl leading-relaxed">
            {DISCLAIMER}
          </p>
        </div>
      </div>
    </footer>
  );
}
